import React, { Component, Fragment } from 'react';
import { CloseCircleFilled } from '@ant-design/icons';
import { Select, Input, Checkbox } from 'antd';
import UnitAddonAfter from '../UnitAddonAfter';
import { numberCheck } from '@/services/helper/dataProcess';
import { unitChange } from '@/services/helper/mathHelper';
import _ from "lodash";
import './ModelPin.css';
import { MAXIMAL_LENGTH_LFSR, USER_DEFINED_LFSR, USER_DEFINED_SEQUENCE, PRBS_ADS, adsDelayList, PSEC, NONE } from '../../services/Rocky/ADS/constant';
import { StimulusPRBSModelConfig } from '../../services/Rocky/ADS/dataHelper';
import { isDiffSignal } from '../../services/Rocky/helper/setupData';

const ADS_MODES = [{ key: "Maximal Length LFSR", value: MAXIMAL_LENGTH_LFSR }, { key: "User Defined LFSR", value: USER_DEFINED_LFSR }, { key: "User Defined Sequence", value: USER_DEFINED_SEQUENCE }]

class ModelPin extends Component {
  constructor(props) {
    super(props);
    const { record, defaultDelayUnit, product } = props;
    let adsStimulus = record && record.adsStimulus ? record.adsStimulus : {};
    this.state = this.initState({ adsStimulus, defaultDelayUnit, product });
  }

  initState = ({ adsStimulus = {}, defaultDelayUnit, product }) => {
    const { mode, delay, seed, taps, registerLength, bitSequence } = adsStimulus;
    let inputMode = "", inputSeed = "", inputLength = "7", inputTaps = "", inputBitSequence = "",
      inputDelay = '0', inputUnit = { delay: 'ps' };

    if (delay) {
      let delayUnit = delay.replace(/^[-0-9.]+/, '');
      if (!delayUnit) { delayUnit = NONE }
      inputUnit.delay = delayUnit;
      inputDelay = delay.replace(/[A-Za-z]/g, '');
    }

    inputMode = mode || mode === MAXIMAL_LENGTH_LFSR ? mode : inputMode;
    inputLength = registerLength ? registerLength : inputLength;
    inputSeed = seed ? seed : inputSeed;
    inputTaps = taps ? taps : inputTaps;
    inputBitSequence = bitSequence ? bitSequence : inputBitSequence;

    return {
      inputMode,
      inputSeed,
      inputLength,
      inputTaps,
      inputBitSequence,
      inputDelay,
      inputUnit,
      applyAll: this.props.applyAll,
      error: "",
      applyAllDriver: false
    }
  }

  componentDidMount = () => {
    if (this.props.onChildRef) {
      this.props.onChildRef(this);
    }
  }

  onModelChange = (value) => {
    let updateInfo = { inputMode: value }
    const { inputLength, inputTaps, inputSeed, inputBitSequence } = this.state;
    const { record } = this.props;
    const { signal } = record;
    // diff model default value
    const isDiff = isDiffSignal(signal)
    switch (value) {
      case MAXIMAL_LENGTH_LFSR:
        updateInfo = {
          ...updateInfo,
          inputLength: inputLength || '8'
        }
        break;
      case USER_DEFINED_LFSR:
        updateInfo = {
          ...updateInfo,
          inputTaps: inputTaps ? inputTaps : isDiff ? '010101' : '01000100111011010',
          inputSeed: inputSeed ? inputSeed : isDiff ? '010101' : '11010111011101010',
        }
        break;
      case USER_DEFINED_SEQUENCE:
        updateInfo = {
          ...updateInfo,
          inputBitSequence: inputBitSequence ? inputBitSequence : isDiff ? '01010101' : '10101010'
        }
        break;
      default:
        break;
    }
    this.setState(updateInfo, () => { this.props.setContentHeight(0) })
  }

  inputBlur = (e, type) => {
    const value = e.target.value;
    // to do
    // Error check
  }

  inputChange = (e, type) => {
    this.setState({
      [type]: e.target.value
    })
  }

  changeSlewAndDelayType = (e, type) => {
    if (e && e.target && e.target.value) {
      this.setState({
        [type]: { type: e.target.value, value: '' }
      })
    }
  }

  changeInputUnit = (key, dataType) => {
    this.setState({
      inputUnit: {
        ...this.state.inputUnit,
        [dataType]: key
      }
      // }, () => {
      // this.saveSlewAndDelay(stateKey, title, dataType)
    })
  }

  changeSlewAndDelayValue = (e, key) => {
    const value = e.target.value;
    const data = this.state[key];
    this.setState({
      [key]: { ...data, value }
    })
  }

  saveSlewAndDelay = (key, title, type) => {
    const data = this.state[key];
    const { clock } = this.props;
    let unit = '', error = '';
    if (data.type === 'absolute') {
      unit = this.state.inputUnit[type];
    }
    if (numberCheck(data.value)) {
      error = `${title} must be a number.`;
    } else if (Number(data.value) <= 0) {
      error = `${title} must be greater than 0.`;
    } else if (type === 'slew') {
      if (data.type === 'percent' && data.value >= 20) {
        error = `${title} must be less than 20%.`
      } else if (data.type === 'absolute') {
        const cycle = 1 / unitChange({ num: clock.value, oldUnit: `${clock.unit}Hz`, newUnit: 'Hz', decimals: -1 }).number;
        const maxSlew = unitChange({ num: cycle * 0.2, oldUnit: 's', newUnit: unit, decimals: -1 });
        if (maxSlew.number < data.value) {
          error = `${title} must be less than ${Number(maxSlew.number.toFixed(5))}${unit}`;
        }
      }
    } else if (type === "dutyCycle" && data.type === "percent" && Number(data.value) > 100) {
      error = `${title} must be less than or equal to 100%.`;
    }

    this.setState({
      error,
    }, () => {
      this.props.setContentHeight(0);
    })
  }

  onApplyChange = (e, key) => {
    this.setState({
      [key]: e.target.checked
    })
  }

  savePinValue = () => {
    const { inputMode, inputSeed, inputLength, inputTaps,
      inputBitSequence, inputDelay, inputUnit, applyAll } = this.state;
    const { record, saveModelPins } = this.props;
    const { signal, component, net, pin, ...restProps } = record;

    function scientificToNumber(scientificStr) {
      return Number(scientificStr);
    }

    let error = '';
    const delayData = scientificToNumber(inputDelay)
    const delay = inputUnit.delay === 'None' ? delayData : `${delayData}${inputUnit.delay}`
    const isDiff = isDiffSignal(signal)
    const adsStimulusInfo = new StimulusPRBSModelConfig({
      mode: inputMode,
      registerLength: inputLength,
      taps: inputTaps,
      seed: inputSeed,
      bitSequence: inputBitSequence,
      delay
    }, isDiff)
    saveModelPins({ record: { ...restProps, component, pin, net, signal }, adsStimulus: adsStimulusInfo, applyAll, isAds: true });
  }

  getAddonAfter = (dataType) => {
    const { inputUnit } = this.state;
    return UnitAddonAfter({
      unit: inputUnit[dataType],
      changeUnit: (key) => this.changeInputUnit(key, dataType),
      list: ["fs", "ps", "ns", "us", "ms", "s"]
    });
  }

  clearError = () => {
    this.setState({ error: "" }, () => { this.props.setContentHeight(0) });
  }

  enterDown = (e) => {
    e.target.blur();
  }

  inputComponent = ({
    title,
    type,
    value,
    addonAfter
  }) => {
    return <div className='stimulus-setup-model clear'>
      <div className='stimulus-setup-model-title'>{title}</div>
      <Input
        placeholder={title}
        size='small'
        value={value}
        onChange={(e) => this.inputChange(e, type)}
        className='stimulus-setup-model-select'
        onBlur={e => this.inputBlur(e, type)}
        onFocus={() => { this.clearError() }}
        onPressEnter={e => this.enterDown(e)}
        addonAfter={addonAfter ? addonAfter() : null}
      />
    </div>
  }

  getModeContent = () => {
    const { inputMode, inputLength, inputTaps, inputSeed, inputBitSequence } = this.state;
    switch (inputMode) {
      case MAXIMAL_LENGTH_LFSR:
        return <Fragment>
          {this.inputComponent({
            title: 'Register Length',
            type: 'inputLength',
            value: inputLength,
          })}
        </Fragment>
      case USER_DEFINED_LFSR:
        return <Fragment>
          {this.inputComponent({
            title: 'Taps',
            type: 'inputTaps',
            value: inputTaps,
          })}
          {this.inputComponent({
            title: 'Seed',
            type: 'inputSeed',
            value: inputSeed,
          })}
        </Fragment>
      case USER_DEFINED_SEQUENCE:
        return <Fragment>
          {this.inputComponent({
            title: 'Bit Sequence',
            type: 'inputBitSequence',
            value: inputBitSequence,
          })}
        </Fragment>
      default:
        return null;
    }
  }

  render() {
    const { inputMode, inputDelay, applyAll } = this.state;
    return <Fragment>
      <div>
        <div className='stimulus-setup-model clear'>
          <div className='stimulus-setup-model-title'>Mode</div>
          <Select
            placeholder="Mode"
            className='stimulus-setup-model-select'
            value={inputMode}
            onChange={(value) => this.onModelChange(value)}
            popupMatchSelectWidth={false}
            popupClassName='stimulus-setup-model-select-dropdown'
            size='small'
            allowClear={{ clearIcon: <CloseCircleFilled onClick={(e) => this.cleanType(e)} /> }}
            options={ADS_MODES.map(item => ({
              value: item.value,
              label: item.key,
            }))}
          />
        </div>
        {this.getModeContent()}
        {this.inputComponent({
          title: 'Delay',
          type: 'inputDelay',
          value: inputDelay,
          addonAfter: () => this.getAddonAfter('delay')
        })}
        <div className='stimulus-setup-model clear'>
        </div>
        <div className='stimulus-setup-model clear'>
          <div className='stimulus-apply-model-title'>Apply the stimulus to all the pins in the component</div>
          <Checkbox
            className='stimulus-model-apply-checkbox'
            checked={applyAll}
            onChange={(e) => this.onApplyChange(e, "applyAll")}
          />
        </div>
      </div>
    </Fragment>
  }
}

export default ModelPin;